// extracted by css-extract-rspack-plugin
export default {"optionsIcon":"YAKR4"};